module.exports = __webpack_public_path__ + "fonts/regular.a78bf184.woff2";